import * as t from 'io-ts';
import { optional } from '@/api/validators/helper';
import { status, venueNullName } from '@/api/validators/score';

const tennisTeams = t.type({
  side: optional(t.keyof({a: null, b: null})),
  sets: optional(t.number),
  players: t.array(t.string),
});

const setSides = t.type({
  games: optional(t.number),
  tiebreak: optional(t.number),
});

const sets = t.type({
  a: setSides,
  b: setSides,
});

const match = t.type({
  matchDate: t.string,
  matchStatus: t.string,
  noSets: optional(t.number),
  winner: optional(t.string),
  sets: t.array(sets),
  teams: t.tuple([tennisTeams, tennisTeams]),
});

const roundMatches = t.type({
  roundTitle: t.string,
  matches: t.array(match),
});

const tennisTournament = t.type({
  data: t.array(roundMatches),
  eventDateStart: t.string,
  eventDateEnd: t.string,
  eventId: t.string,
  eventName: t.string,
  eventType: t.string,
  gender: t.string,
  matchType: t.string,
  status,
  subStatus: optional(status),
  surfaceType: t.string,
  tourName: t.string,
  tourTitle: t.string,
  tournamentName: t.string,
  venue: venueNullName,
});

export const tennisResultsApiResponse = tennisTournament;
export type TennisTournamentApi = t.TypeOf<typeof tennisResultsApiResponse>;
